var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zmanim-list__container"},_vm._l((_vm.items),function(item){return _c(_vm.componentForItem(item),_vm._b({key:item.key,tag:"component",class:_vm.classForItem(item)},'component',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }